import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Textbox, DropdownList } from 'adp-react-components';
import SecurityQnA from './../../../components/utils/security-qna.js';

export default class CreateSecurityQnA extends React.Component {
  constructor(props) {
    console.log('constructor initialized for CreateSecurityQnA');
    super(props);
    this.state = {
      question1: -1,
      question2: -1,
      question3: -1,
      answer1: '',
      answer2: '',
      answer3: ''
    };
  }

  getAnswer1(value) {
    this.setState({
      answer1: value
    });
  }
  getAnswer2(value) {
    this.setState({
      answer2: value
    });
  }
  getAnswer3(value) {
    this.setState({
      answer3: value
    });
  }
  getQuestion1(value) {
    this.setState({
      question1: value
    });
  }
  getQuestion2(value) {
    this.setState({
      question2: value
    });
  }
  getQuestion3(value) {
    this.setState({
      question3: value
    });
  }
  onSubmit(event) {
    gtag('event', 'Enroll|SecurityQnA|Click', {
      'event_category': 'Admin Login',
      'event_label': 'SecurityQnA'
    });
    if (
      this.state.question1 == -1 ||
      this.state.question2 == -1 ||
      this.state.question3 == -1
    ) {
      this.props.showErrorMessage(this.props.noQuestionBlank, 'error');
      return;
    }
    if (
      this.state.answer1 == '' ||
      this.state.answer2 == '' ||
      this.state.answer3 == ''
    ) {
      this.props.showErrorMessage(this.props.noAnswerBlank, 'error');
      return;
    }
    if (
      this.state.answer1.toUpperCase() == this.state.answer2.toUpperCase() ||
      this.state.answer1.toUpperCase() == this.state.answer3.toUpperCase() ||
      this.state.answer2.toUpperCase() == this.state.answer3.toUpperCase()
    ) {
      this.props.showErrorMessage(this.props.noAnswerSame, 'error');
      return;
    }
    try {
      fetch(context+'/enroll/adpPassword.faces?enrollSetQuestionsForm=', {
        method: 'POST',
        credentials: 'same-origin',

        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body:
          'enrollSetQuestionsForm=enrollSetQuestionsForm&question=' +
          this.state.question1 +
          '&question=' +
          this.state.question2 +
          '&question=' +
          this.state.question3 +
          '&answer=' +
          this.state.answer1 +
          '&answer=' +
          this.state.answer2 +
          '&answer=' +
          this.state.answer3 +
          '&enrollSetQuestionsForm:submitButton=&javax.faces.ViewState=' +
          Tier0.get('javax.faces.ViewState').value
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.success == 'false' || data.success == false) {
            this.props.showErrorMessage(data.wizard.message, 'error');
            return;
          }
          if (data.success == 'true' || data.success == true) {
            fetch(context+'/enroll/adpPassword.faces?enrollRiskAndPostEvalForm', {
              method: 'POST',
              //same-origin is needed to keep the cookies
              credentials: 'same-origin',
              headers: {
                Accept:
                  'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body:
                'enrollRiskAndPostEvalForm=enrollRiskAndPostEvalForm&enrollRiskAndPostEvalForm:submitButton=&pm_fp=' +
                btoa(Tier0.get('pm_fp_enroll').value) +
                '&javax.faces.ViewState=' +
                Tier0.get('javax.faces.ViewState').value
            })
              .then(response => {
                return response.json();
              })
              .then(data => {
                if (data.success == 'false' || data.success == false) {
                  this.props.showErrorMessage(data.wizard.message, 'error');
                  return;
                }
                window.location.href = context+'/enroll/redirect.faces';
              });
          }
        });
    } catch (error) {
      console.log('error:' + error);
    }
  }
  isButtonEnabled() {
    if (
      this.state.answer1 != '' &&
      this.state.answer2 != '' &&
      this.state.answer3 != ''
    )
      return false;
    else return true;
  }
  render() {
    let isValid=this.isButtonEnabled();
      return (
        <div className="vdl-row login-form">
          <div className="vdl-col-md-12">
            <form className="adp-form">
        <SecurityQnA
        showErrorMessage={this.props.showErrorMessage.bind(this)}
        question1Lable={this.props.question1Lable}
        question2Lable={this.props.question2Lable}
        question3Lable={this.props.question3Lable}
        answerLable={this.props.answerLable}
        getAnswer1={this.getAnswer1.bind(this)}
        getAnswer2={this.getAnswer2.bind(this)}
        getAnswer3={this.getAnswer3.bind(this)}
        getQuestion1={this.getQuestion1.bind(this)}
        getQuestion2={this.getQuestion2.bind(this)}
        getQuestion3={this.getQuestion3.bind(this)}
        showTermCondition={this.props.showTermCondition.bind(this)}
        fetchTermsnConditions={this.props.fetchTermsnConditions.bind(this)}
        updateModelFlag={this.props.updateModelFlag.bind(this)}
        select={this.props.select}
        onSubmit={ this.onSubmit.bind(this)}
        isButtonEnabled={this.isButtonEnabled.bind(this)}
        />
        <div className="form-group submit vdl-text-xs-center">

          <Button
            className="primary"
            onClick={ this.onSubmit.bind(this)}
            disabled={isValid }>
            {this.props.continueButton}
          </Button>
        </div>
        </form >
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/admin-login/enroll/security-questions.js